import { MembershipAttributes } from './membership';
import { ProfileRewardAttributes, TransactionAttributes } from './transaction';

export type CustomKeyTypes = string | boolean | number | Date | null | undefined;

export interface CurrencyBalanceAttributes {
  id: string;
  version: number;
  programId: string;
  currencyId: string;
  value: number;
  totalAccumulated: number;
  totalOverCurrencyPeriod: number;
  totalOverLevelPeriod: number;
  firstTimeEarned: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  nextExpiration?: NextExpiration | null;
}

export interface NextExpiration {
  date: string;
  amount: number;
}

export interface ProfileIdentity {
  kind: ProfileIdentityKind | string;
  value: string;
  programId?: string;
}

export enum ProfileIdentityKind {
  email = 'email',
  instagram = 'instagram',
  facebook = 'facebook',
  keycloakId = 'keycloak_id',
  referralCode = 'referralCode',
  memberCode = 'member_code',
}

export enum ProfileState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  PENDING = 'PENDING',
}

export interface Address {
  street?: string;
  number?: string;
  box?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  city?: string;
}

export interface ProfileUpsert {
  id?: string;
  isTestUser?: boolean;
  identities?: ProfileIdentity[];
  memberships?: ProfileUpsertMembership[];
  firstName?: string;
  lastName?: string;
  language?: string;
  birthday?: string;
  picture?: string | null;
  currencies?: CurrencyBalanceAttributes[];
  address?: Address;
  phone?: string;
  gender?: string;
  email?: string;
  customKeys?: Record<string, CustomKeyTypes>;
  referralCode?: string;
}

export interface ProfileUpsertMembership {
  programId: string;
  accessDenied?: boolean;
}

export interface ProfileAttributes {
  id: string;
  numericalId: number;
  isTestUser?: boolean;
  externalId?: string;
  accountId: string;
  version: number;
  state: ProfileState;
  firstName?: string;
  lastName?: string;
  language: string;
  birthday?: string;
  picture?: string;
  email: string;
  currencies: CurrencyBalanceAttributes[];
  address?: Address;
  phone?: string;
  gender?: string;
  customKeys?: Record<string, any>;
  createdAt?: string;
  updatedAt?: string;
  identities?: ProfileIdentity[];
  transactions?: TransactionAttributes[];
  memberships?: MembershipAttributes[];
  rewards?: ProfileRewardAttributes[];
}

export enum GetProfileIncludeOptions {
  currencies = 'currencies',
  transactions = 'transactions',
  rewards = 'rewards',
  memberships = 'memberships',
  identities = 'identities',
}

export interface NewLevel {
  membershipId: string;
  programId: string;
  levelId: string;
  acquiredAt: string;
  expireAt?: string;
}

export enum ImpactMessageLevel {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export interface ApplyImpactMessage {
  level: ImpactMessageLevel;
  message: string;
}

export interface ApplyImpactResponse {
  newProfileVersion: number;
  transactions: TransactionAttributes[];
  rewards?: ProfileRewardAttributes[];
  newLevels: NewLevel[];
  currencyBalances: CurrencyBalanceAttributes[];
  messages: ApplyImpactMessage[];
}

export interface UpsertProfileResponse {
  profile: ProfileAttributes;
  memberships: MembershipAttributes[];
  identities: ProfileIdentity[];
  impersonationToken?: string;
}

export interface ProfileLevel {
  current?: string;
  acquiredAt?: string;
  expireAt?: string;
}
